import { render } from "./FormConstructor.vue?vue&type=template&id=6bb73218&scoped=true"
import script from "./FormConstructor.vue?vue&type=script&lang=js"
export * from "./FormConstructor.vue?vue&type=script&lang=js"

import "./FormConstructor.vue?vue&type=style&index=0&id=6bb73218&lang=css"
import "./FormConstructor.vue?vue&type=style&index=1&id=6bb73218&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb73218"]])

export default __exports__